<template>
    <!-- 新建工单 -->
    <div class="rzy-page">
        <div class="rzy-top-bar">
            <el-button type="primary" @click="creatShipmentOrder" style="" icon="el-icon-circle-plus">提交</el-button>
        </div>

        <div class="form-wrap">
            <el-card>

                <el-form :model="g_shipmentInfo" :rules="g_warehouseRelues" ref="warehouseFormRef" inline size="mini">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="单据日期" prop="createTime">
                                <el-date-picker disabled="isDisabled" style="padding-left: 10px;"
                                    v-model="g_shipmentInfo.createTime" type="date" size="large"
                                    value-format="timestamp">
                                </el-date-picker>
                            </el-form-item>

                            <el-form-item label="单据编号" prop="shipNumber">
                                <el-input v-model="g_shipmentInfo.shipNumber" disabled="isDisabled" placeholder="自动生成">
                                </el-input>
                            </el-form-item>

                            <el-form-item label="客户名称" prop="customer">
                                <el-input v-model="g_shipmentInfo.customer" placeholder="请输入">
                                </el-input>
                            </el-form-item>

                            <el-form-item label="业务员" prop="contact">
                                <el-input v-model="g_shipmentInfo.contact" placeholder="请输入">
                                </el-input>
                            </el-form-item>

                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="地址" prop="address" class="full-width">
                                <el-input v-model="g_shipmentInfo.address" placeholder="请输入" type="textarea" :rows="2">
                                </el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="备注" prop="remark" class="full-width">
                                <el-input v-model="g_shipmentInfo.remark" placeholder="请输入" type="textarea" :rows="2">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

            </el-card>
        </div>

        <el-row :gutter="10" style="margin-top:10px">
            <el-col :lg="24" :md="24" :sm="24">
                <div class="form-wrap mini auto-width">
                    <div class="toolbar">
                        <div class="col-header">计划出货清单</div>
                        <el-button type="primary" size="mini" icon="el-icon-circle-plus"
                            @click="$refs.materialSelect.show(g_position_index)">
                            增行
                        </el-button>
                    </div>
                    <el-table :data="g_shipmentInfo.items" class="craft-order" :row-style="{height: '0'}"
                        :header-cell-style="{padding: 0}" border @selection-change="handleSelectionChange">

                        <el-table-column fixed label="行" width="50px" prop="lineNo" align="center" />

                        <el-table-column label="物料编号" width="150" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.materialNumber" disabled="isDisabled" placeholder="未选择">
                                </el-input>
                            </template>
                        </el-table-column>

                        <el-table-column label="物料名称" width="150" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.materialName" disabled="isDisabled" placeholder="未选择">
                                </el-input>
                            </template>
                        </el-table-column>

                        <!-- hcy: "单位"这个数据后台会直接从原料中读取并设置到字段中，前端可以不用传递，只负责显示即可。 -->
                        <el-table-column label="单位" width="100" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.unit" disabled="isDisabled" placeholder="千克"></el-input>
                            </template>
                        </el-table-column>

                        <el-table-column label="计划出货数量" width="100" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.count" />
                            </template>
                        </el-table-column>

                        <el-table-column label="" width="100" align="center">
                            <template slot-scope="data">
                                <el-button type="primary" size="mini" icon="el-icon-remove"
                                    @click="delDialogOpend(data.row.lineNo)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>

        </el-row>


		<!-- 物料选择 弹框 -->
        <material-select ref="materialSelect" @update="updateMaterialDialog()" />
        <!-- 查询物料选择仓位 弹框 -->
        <!-- <material-select-position ref="materialSelectPosition" @update="updateMaterialDialog()" /> -->

        <!-- 删除 对话框 -->
        <el-dialog title="删除物料" :visible.sync="delDialogVisible" width="20%" @close="delDialogClosed">
            <el-form ref="delFormRef" label-width="90px" :model="delForm">
                <el-form-item label="确定删除?">
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="delWarehouse">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
	import {
	    MaterialSelect
	} from '../../../../components/materialSelect'
    import {
        MaterialSelectPosition
    } from '../../../../components/materialSelectPosition'

    export default {
        components: {
			MaterialSelect,
            MaterialSelectPosition,
        },
        data() {
            // 非负浮点数 检测
            var floatCheck = (rules, value, cb) => {
                const ruler = /^\d+(\.\d+)?$/
                if (ruler.test(value)) {
                    return cb()
                }
                cb(new Error('请输入非负浮点数'))
            }


            return {
                g_position_index: 1,

                g_shipmentInfo: {
                    createTime: (new Date()).getTime(), //单据日期
                    shipNumber: '', // 单据编号
                    customer: '', //客户名称
                    contact: '', //业务员(负责人)
                    address: '', //地址
                    remark: '', //备注

                    //仓位列表
                    items: [
                        // {
						// id:
                        // materialId: 0, //物料ID
                        // count: 0, //数量
                        // },
                    ],
                    items_org: [], //备份后台原始数据
                    items_del: [], //本地删除的数据
                },

                g_warehouseRelues: {
                    XXXX: [{
                        required: true,
                        message: 'XXXXXX',
                        trigger: 'blur'
                    }],

                },

                delDialogVisible: false, //删除 对话框
                g_delIndex: 0, //删除按钮点击了哪一行
            }
        },
        methods: {

            //创建or修改  仓库
            creatShipmentOrder() {
				// console.log(this.g_shipmentInfo)
				// return
                // 判定数据  是否都填好了
                if (!this.checkMaterialTable()) {
                    return
                }

                //hcy: 数量和之前原料是一样的处理，后端传递过来，前端需要转换下。
                for (let i = 0; i < this.g_shipmentInfo.items.length; i++) {
                    this.g_shipmentInfo.items[i].count = Number(this.hmjDataChange(this.g_shipmentInfo.items[i]
                        .count)) * 100 //数量
                }

                switch (this.$route.query.type) {
                    case 0: // 新建
                        this.$requestBase({
                            url: 'v1/ship/order/create',
                            method: 'POST',
                            data: this.g_shipmentInfo
                        }, true).then(res => {
                            this.$Message.success(res.info)
                            this.$router.push('shipmentOrderList')
                        })
                        break;
                    case 1: // 编辑
                        // 编辑时候，注意把 删除记录 抢救回来。
                        for (let i = 0; i < this.g_shipmentInfo.items_del.length; i++) {
                            this.g_shipmentInfo.items_del[i].count = Number(this.hmjDataChange(this.g_shipmentInfo
                                .items_del[i].count)) * 100 //数量

                            this.g_shipmentInfo.items.push(this.g_shipmentInfo.items_del[i])
                        }

                        this.$requestBase({
                            url: 'v1/ship/order/update',
                            method: 'POST',
                            data: this.g_shipmentInfo
                        }, true).then(res => {
                            this.g_shipmentInfo.items_del = [] //为了安全，提供成功后，把临时删除列表 初始化。
                            this.$Message.success(res.info)
                            this.$router.push('shipmentOrderDetalis/' + this.$route.query
                                .shipmentId) //注意这里应该返回 详情页面
                        })

                        break;
                    default:
                        break;
                }


            },



            // 字符串 '2.34512345' 四舍五入成 2位小数=2.35, 再转换成 字符串 '2.35'。注意禁止使用toFixed()。
            // https://wenku.baidu.com/view/a20d74dcadf8941ea76e58fafab069dc50224761.html
            hmjDataChange(inputStr) {
                let data1 = Number(inputStr) // 先转数字
                //Math.round()方法用来把一个数字舍入为最接近的整数
                let data2 = Math.round(data1 * 100) / 100
                return (data2.toString()) //转字符串
            },

            // 根据ID，获取信息 -- 编辑专用
            getShipmentInfo(type, shipmentId) {
                this.$requestBase({
                    url: 'v1/ship/order/detail',
                    method: 'get',
                    params: {
                        id: shipmentId
                    }
                }).then(res => {
                    res = res.data
                    //this.g_shipmentInfo = res
                    this.formatResponse(res)
                })
            },


            //格式化 返回结果 -- 编辑专用
            formatResponse(res) {
                this.g_shipmentInfo = res

                for (let i = 0; i < this.g_shipmentInfo.items.length; i++) {
                    this.g_shipmentInfo.items[i].lineNo = i + 1 //手动行号

                    //hcy: 数量和之前原料是一样的处理，后端传递过来，前端需要转换下。
                    this.g_shipmentInfo.items[i].count = (this.g_shipmentInfo.items[i].count / 100).toFixed(
                        2) //数量
                    // this.g_shipmentInfo.items[i].stock = (this.g_shipmentInfo.items[i].stock / 100).toFixed(2) //库存
                }

                this.g_shipmentInfo.items_org = this.g_shipmentInfo.items //先备份原始数据。
                this.g_shipmentInfo.items = [] //清空。
                this.g_shipmentInfo.items_del = [] //同时初始化删除列表。

                //为了防止 后台把 已经删除的数据 传给前端，只有 非删除数据 才能加入'物料信息'列表。
                for (let i = 0; i < this.g_shipmentInfo.items_org.length; i++) {
                    if (this.g_shipmentInfo.items_org[i].isDeleted === 1) { //已删除脏数据
                        //do nothing.
                    } else {
                        this.g_shipmentInfo.items[i] = this.g_shipmentInfo.items_org[i]
                    }
                }

                //编辑的时候，下一个要新增的行号 应该 现有行号+1，不能直接=1。
                this.g_position_index = this.g_shipmentInfo.items.length + 1

            },


            //查询物料选择仓位 对话框 返回的处理
            updateMaterialDialog() {
				let selectedMaterial = this.$refs.materialSelect.getPeiBuInfo()
				// console.log(selectedMaterial)
      //           let selectPositionList = this.$refs.materialSelectPosition.getPositionList()
      //           console.log("selectPositionList=", selectPositionList)

                console.log('this.g_position_index = ', this.g_position_index)
                for (let i = 0; i < selectedMaterial.length; i++) {
                    this.g_shipmentInfo.items.push({
                        lineNo: this.g_position_index,
                        materialId: selectedMaterial[i].id,
						materialNumber: selectedMaterial[i].number,
						materialName: selectedMaterial[i].name,
                        unit: selectedMaterial[i].unit, //单位
						count:0
                    })
                    this.g_position_index++
                }

                //通知父组件 '选择XX' 已经成功。
                this.$emit('selectWarehouseFinish')
            },

            //删除 ---------------------------------sta
            // 显示 删除对话框
            delDialogOpend(lineNo) {
                this.g_delIndex = lineNo - 1 //记录下点击了 哪一行的删除按钮。
                this.delDialogVisible = true
            },
            // 监听 删除对话框 的关闭事件
            delDialogClosed() {
                this.$refs.delFormRef.resetFields()
            },
            //删除
            delWarehouse() {

                if ((this.g_position_index - 2) >= 0) {
                    switch (this.$route.query.type) {
                        case 0: // 新建
                            //新建时候，因为还没通知 后台，直接从缓存删除即可。
                            this.g_shipmentInfo.items.splice(this.g_delIndex, 1) //删除1条记录。
							for(let i = this.g_delIndex; i<this.g_shipmentInfo.items.length;i++){
								this.g_shipmentInfo.items[i].lineNo -= 1;
							}
                            break;
                        case 1: // 编辑
                            // bug: 不能直接删除items[X],要设置isDeleted=1。--sta
                            // console.log('this.g_shipmentInfo.items = ', this.g_shipmentInfo.items)
                            // console.log('this.g_shipmentInfo.items_del = ', this.g_shipmentInfo.items_del)

                            this.g_shipmentInfo.items[this.g_delIndex].isDeleted = 1 //先标记为删除。
                            this.g_shipmentInfo.items_del.push(this.g_shipmentInfo.items[this
                                .g_delIndex]) //移动到已删除列表
                            this.g_shipmentInfo.items.splice(this.g_delIndex, 1) //删除1条记录。
							for(let i = this.g_delIndex; i<this.g_shipmentInfo.items.length;i++){
								this.g_shipmentInfo.items[i].lineNo -= 1;
							}
                            // console.log('this.g_shipmentInfo.items = ', this.g_shipmentInfo.items)
                            // console.log('this.g_shipmentInfo.items_del = ', this.g_shipmentInfo.items_del)
                            // bug: 不能直接删除items[X],要设置isDeleted=1。--end
                            break;
                        default:
                            break;
                    }
                    this.g_position_index--
                }

                this.delDialogVisible = false
            },
            //删除 ---------------------------------end

            //检查物料信息表中 是否 有的行 没有选择物料?
            checkMaterialTable() {
                for (let i = 0; i < this.g_shipmentInfo.items.length; i++) {
                    // console.log('this.g_shipmentInfo.items[i].materialName=', this.g_shipmentInfo.items[i]
                    //     .materialName)
                    if (this.g_shipmentInfo.items[i].materialName === undefined) {
                        this.$Message.error('无法提交，物料信息表中某些行未选择物料！')
                        return false
                    }
                }
                return true
            },
        },
        created() {},
        // mounted:html加载完成后执行。执行顺序：子组件-父组件
        mounted() {
            switch (this.$route.query.type) {
                case 1: // 编辑
                    this.getShipmentInfo(this.$route.query.type, this.$route.query.shipmentId)
                    break;
                case 0: // 新建
                default:
                    break;
            }
        },
        beforeDestroy() {},
        destroyed() {}

    }
</script>

<style lang="scss" scoped>

</style>
